var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 27.3307C21.3641 27.3307 27.3337 21.3611 27.3337 13.9974C27.3337 6.63359 21.3641 0.664062 14.0003 0.664062C6.63652 0.664062 0.666992 6.63359 0.666992 13.9974C0.666992 21.3611 6.63652 27.3307 14.0003 27.3307ZM12.2583 19.1251L18.5519 15.4094C19.5942 14.7939 19.5942 13.2009 18.5519 12.5854L12.2583 8.86965C11.2453 8.27154 10.0003 9.05002 10.0003 10.2816V17.7131C10.0003 18.9447 11.2453 19.7233 12.2583 19.1251Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.5764605f57233e2e6ee5489c015d32d1.svg";
export { ForwardRef as ReactComponent };